import React from 'react';
import { Bar } from 'react-chartjs-2';
import { LeaderboardEntry } from '../types';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

// Register ChartJS components
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

interface LeaderboardChartProps {
  users: LeaderboardEntry[];
  metric: keyof Omit<LeaderboardEntry, 'userId' | 'email'>;
  metricName: string;
}

const LeaderboardChart: React.FC<LeaderboardChartProps> = ({ users, metric, metricName }) => {
  // Take the top 10 users for the chart
  const topUsers = users.slice(0, 10);

  const data = {
    labels: topUsers.map(user => {
      // Format the email for display (show only the username part)
      const emailParts = user.email.split('@');
      return emailParts[0];
    }),
    datasets: [
      {
        label: metricName,
        data: topUsers.map(user => user[metric] as number),
        backgroundColor: 'rgba(53, 162, 235, 0.5)',
        borderColor: 'rgb(53, 162, 235)',
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top' as const,
      },
      title: {
        display: true,
        text: `Top 10 Users by ${metricName}`,
        font: {
          size: 16,
        },
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: metricName,
        },
      },
      x: {
        title: {
          display: true,
          text: 'User',
        },
      },
    },
  };

  return (
    <div className="chart-container" style={{ height: '400px' }}>
      <Bar data={data} options={options} />
    </div>
  );
};

export default LeaderboardChart; 